// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"654":"8b7738b1","787":"b1718b27"}[chunkId] + ".chunk.js";
};